import React from 'react';
import { DashboardPageHeader } from '../../../Components/Common/DashboardKit';
import { Container } from 'reactstrap';

import List from './List';

const ProjectList = () => {
    document.title = "Project List | Velzon - React Admin & Dashboard Template";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-folders-line"
                        title="Project List"
                        subtitle="Browse and manage your projects"
                        tone="default"
                        breadcrumb={[
                            { label: "Projects" },
                            { label: "Project List" },
                        ]}
                    />
                    <List />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default ProjectList;